import { UserPermissionType } from '../types/commonTypes';
import {
  CLIENTS_ROUTE,
  SETTINGS_ROUTE,
  COACHES_ROUTE,
  APPLICATIONS_ROUTE,
  ACTIVITY_LIBRARY_ROUTE,
  ARCHIVED_CLIENTS_ROUTE,
  ARCHIVED_COACHES_ROUTE,
  USER_GROUPS_ROUTE,
  SUBSCRIPTION_PLANS,
  CALENDAR_SETTINGS_ROUTE,
  VIEW_BOOKINGS_ROUTE,
  PAYMENT_SETTINGS_ROUTE,
  MANAGE_TEAM_ROUTE,
} from '../utils/routes';

export const clientManagementData = [
  {
    id: 1,
    title: 'common.modules.activeClients',
    subtitle: 'common.modules.subtitles.activeClients',
    url: CLIENTS_ROUTE,
    src: '/assets/icons/clients.svg',
    boldIcon: '/assets/icons/users-group-bold.svg',
    main: 'common.management.client',
    permissions: [UserPermissionType.CORE_MODULE_GET_CLIENTS],
  },
  {
    id: 2,
    title: 'common.modules.archivedClients',
    subtitle: 'common.modules.subtitles.archivedClients',
    url: ARCHIVED_CLIENTS_ROUTE,
    src: '/assets/icons/archived-clients.svg',
    boldIcon: '/assets/icons/archived-clients-bold.svg',
    permissions: [UserPermissionType.CORE_MODULE_VIEW_ARCHIVE_CLIENTS],
  },
];
export const coachManagementData = [
  {
    id: 1,
    title: 'common.modules.activeCoaches',
    subtitle: 'common.modules.subtitles.activeCoaches',
    url: COACHES_ROUTE,
    src: '/assets/icons/client.svg',
    boldIcon: '/assets/icons/users-group-rounded.svg',
    permissions: [UserPermissionType.COACH_MODULE_VIEW_ACTIVE_COACHES],
    main: 'common.management.coach',
  },
  {
    id: 2,
    title: 'common.modules.archivedCoaches',
    subtitle: 'common.modules.subtitles.archivedCoaches',
    url: ARCHIVED_COACHES_ROUTE,
    src: '/assets/icons/client.svg',
    boldIcon: '/assets/icons/users-group-rounded.svg',
    permissions: [UserPermissionType.COACH_MODULE_VIEW_ARCHIVE_COACHES],
  },
];
export const contentManagementData = [
  {
    id: 1,
    title: 'common.modules.activityLibrary',
    subtitle: 'common.modules.subtitles.activityLibrary',
    url: ACTIVITY_LIBRARY_ROUTE,
    src: '/assets/icons/activity-library.svg',
    boldIcon: '/assets/icons/folder-bold-icon.svg',
    permissions: [UserPermissionType.ACTIVITY_LIBRARY_MODULE_GET_ACTIVITY_LIBRARY],
    main: 'activityLibrary.management.activity',
  },
];

export const billingSectionData = [
  {
    id: 1,
    title: 'common.modules.paymentSettings',
    subtitle: 'common.modules.subtitles.paymentSettings',
    url: PAYMENT_SETTINGS_ROUTE,
    src: '/assets/icons/payment-settings.svg',
    boldIcon: '/assets/icons/payment-settings-bold.svg',
    main: 'common.management.billing',
  },
  {
    id: 2,
    title: 'common.modules.mySubscription',
    subtitle: 'common.modules.subtitles.mySubscription',
    url: SUBSCRIPTION_PLANS,
    src: '/assets/icons/subscription-icon.svg',
    boldIcon: '/assets/icons/subscription-icon-bold.svg',
    main: 'common.management.billing',
  },
];

export const settingsData = [
  {
    id: 2,
    title: 'common.modules.settings',
    url: SETTINGS_ROUTE,
    src: '/assets/icons/security-settings.svg',
    boldIcon: '/assets/icons/security-settings-bold.svg',
    main: 'common.management.settings',
    subtitle: 'common.modules.subtitles.settings',
  },
  {
    id: 3,
    title: 'common.modules.userGroups',
    subtitle: 'common.modules.subtitles.userGroups',
    url: USER_GROUPS_ROUTE,
    src: '/assets/icons/user-groups-and-permissions.svg',
    boldIcon: '/assets/icons/user-groups-and-permissions-bold.svg',
    permissions: [UserPermissionType.CORE_MODULE_VIEW_USER_GROUPS],
  },
];

export const bookingManagementData = [
  {
    id: 1,
    title: 'common.modules.viewBookings',
    subtitle: 'common.modules.subtitles.viewBookingsDesc',
    url: VIEW_BOOKINGS_ROUTE,
    src: '/assets/icons/view-bookings.svg',
    boldIcon: '/assets/icons/view-bookings-bold.svg',
    main: 'common.management.bookings',
    permissions: [
      UserPermissionType.BOOKINGS_MODULE_VIEW_BOOKINGS,
      UserPermissionType.BOOKINGS_MODULE_VIEW_COACH_CONFIGURATIONS,
    ],
  },
  {
    id: 2,
    title: 'common.modules.bookingSettings',
    subtitle: 'common.modules.subtitles.calendarSettings',
    url: CALENDAR_SETTINGS_ROUTE,
    src: '/assets/icons/calendar-settings.svg',
    boldIcon: '/assets/icons/calendar-settings-bold.svg',
    permissions: [UserPermissionType.BOOKINGS_MODULE_VIEW_COACH_CONFIGURATIONS],
  },
];

export const hideData = [
  {
    id: 1,
    title: 'common.modules.hide',
    url: '',
    src: '/assets/icons/arrow-left.svg',
    boldIcon: '/assets/icons/menu-dots.svg',
    main: 'common.modules.more',
  },
];

export const staffManagementData = [
  {
    id: 1,
    title: 'common.modules.manageStaff',
    subtitle: 'common.modules.subtitles.manageStaffDesc',
    url: MANAGE_TEAM_ROUTE,
    src: '/assets/icons/staff-icon.svg',
    boldIcon: '/assets/icons/staff-bold-icon.svg',
    permenissions: [UserPermissionType.TEAM_MODULE_VIEW_COACH_GROUP],
  },
];

export const adminNavData = [
  {
    id: 1,
    title: 'common.modules.activeCoaches',
    url: COACHES_ROUTE,
    src: '/assets/icons/client.svg',
    boldIcon: '/assets/icons/users-group-rounded.svg',
  },
  {
    id: 2,
    title: 'common.modules.archivedCoaches',
    url: ARCHIVED_COACHES_ROUTE,
    src: '/assets/icons/client.svg',
    boldIcon: '/assets/icons/users-group-rounded.svg',
  },
  {
    id: 2,
    title: 'common.modules.applications',
    url: APPLICATIONS_ROUTE,
    src: '/assets/icons/folder.svg',
    boldIcon: '/assets/icons/folder-bold.svg',
  },
  {
    id: 3,
    title: 'common.modules.hide',
    url: '',
    src: '/assets/icons/arrow-left.svg',
    boldIcon: '/assets/icons/arrow-right.svg',
  },
];
